module.exports = __webpack_public_path__ + "img/user-15.07e67924.svg";